import { render, staticRenderFns } from "./huawei.vue?vue&type=template&id=e7bac562"
import script from "./huawei.vue?vue&type=script&lang=js"
export * from "./huawei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports